// Redux slice quản lý nhân viên
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";
import { toast } from "react-toastify";

export const fetchNhanVien = createAsyncThunk("nhanVien/fetchNhanVien", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/hr.employee", {
      params: {
        size: params.size || 100,
        order: "id desc",
        page: params.page || 1,
        search: params.search || undefined,
        operating_unit_id: parseInt(localStorage.getItem("selected_operating_unit_id")),
      },
    });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const addNhanVien = createAsyncThunk("nhanVien/addNhanVien", async (payload, { rejectWithValue }) => {
  try {
    const res = await api.post("/hr.employee/create", payload);
    toast.success("Thêm nhân viên thành công!");
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const updateNhanVien = createAsyncThunk("nhanVien/updateNhanVien", async (payload, { rejectWithValue }) => {
  try {
    const res = await api.put(`/hr.employee/${payload.id}`, payload);
    toast.success("Cập nhật nhân viên thành công!");
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const deleteNhanVien = createAsyncThunk("nhanVien/deleteNhanVien", async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/hr.employee/${id}`);
    toast.success("Xóa nhân viên thành công!");
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const fetchKhoa = createAsyncThunk("nhanVien/fetchKhoa", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/medeco.clinic.department", {
      params: {
        size: params.size || 100,
        order: "id desc",
        page: params.page || 1,
      },
    });
    return res.data?.content || [];
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const fetchChuyenKhoa = createAsyncThunk("nhanVien/fetchChuyenKhoa", async (params = {}, { rejectWithValue }) => {
  try {
    const res = await api.get("/medeco.clinic.specialty", {
      params: {
        size: params.size || 100,
        order: "id desc",
        page: params.page || 1,
      },
    });
    return res.data?.content || [];
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const nhanVienSlice = createSlice({
  name: "nhanVien",
  initialState: {
    items: { content: [], totalElements: 0 },
    listKhoa: [],
    listChuyenKhoa: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(fetchNhanVien.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      .addCase(fetchNhanVien.fulfilled, (state, action) => {
        state.items = action.payload || [];
        state.loading = false;
      })
      // .addCase(fetchNhanVien.rejected, (state, action) => {
      //   state.loading = false;
      //   // state.error = action.payload;
      // })
      .addCase(addNhanVien.fulfilled, (state, action) => {
        state.items.content.push(action.payload);
        state.items.totalElements += 1;
      })
      .addCase(updateNhanVien.fulfilled, (state, action) => {
        const idx = state.items.content.findIndex((d) => d.id === action.payload.id);
        if (idx > -1) state.items.content[idx] = { ...state.items.content[idx], ...action.payload };
      })
      .addCase(deleteNhanVien.fulfilled, (state, action) => {
        state.items.content = state.items.content?.filter((d) => d.id !== action.payload);
        state.items.totalElements -= 1;
      })
      .addCase(fetchKhoa.fulfilled, (state, action) => {
        state.listKhoa = action.payload || [];
      })
      .addCase(fetchChuyenKhoa.fulfilled, (state, action) => {
        state.listChuyenKhoa = action.payload || [];
      });
  },
});

export default nhanVienSlice.reducer;
